<template>
  <div class="form-grid">
    <div class="form-item">
      <label class="form-label">上級分類</label>
      <el-cascader v-model="form.parentPath" :options="tree" :props="treeProps" clearable filterable
                   separator=" / " placeholder="無（最上層）"/>
    </div>
    <div class="form-item">
      <label class="form-label required">分類名稱</label>
      <el-input v-model="form.name" placeholder="請輸入分類名稱"/>
    </div>

    <div class="form-item full">
      <label class="form-label">介紹</label>
      <el-input v-model="form.introduction" type="textarea" :rows="3" placeholder="請輸入分類介紹"/>
    </div>

    <upload-box label="分類圖" box-title="分類封面圖" detail="800 × 500 px" :value="form.image"
                @upload="upload($event,'image')"/>
    <div class="form-item">
      <label class="form-label">外鏈</label>
      <el-input v-model="form.externalUrl" placeholder="https://"/>
    </div>

    <div class="form-item">
      <label class="form-label">自訂路由</label>
      <el-input v-model="form.customUrl" placeholder="例如 /career/insight"/>
    </div>
    <div class="form-item">
      <label class="form-label required">同層排序</label>
      <el-input-number v-model="form.sort" :min="0" :controls="false"/>
    </div>

    <div class="form-item">
      <label class="form-label required">前台顯示</label>
      <el-select v-model="form.showFlag">
        <el-option label="是" value="Y"/>
        <el-option label="否" value="N"/>
      </el-select>
    </div>
    <div class="form-item">
      <label class="form-label required">狀態</label>
      <el-select v-model="form.status">
        <el-option label="有效" value="0"/>
        <el-option label="關閉" value="1"/>
      </el-select>
    </div>

    <div class="form-item full notice">
      <i class="el-icon-info"/>
      <span>排序僅與目前相同上級、相同層級的分類比較；數字越小越優先。</span>
    </div>
  </div>
</template>

<script>
import UploadBox from './UploadBox.vue';

export default {
  components: {UploadBox},
  props: {
    form: {type: Object, required: true},
    tree: {type: Array, default: () => []},
    upload: {type: Function, required: true}
  },
  data() {
    return {treeProps: {value: 'id', label: 'name', children: 'children', checkStrictly: true, emitPath: true, expandTrigger: 'hover'}}
  }
}
</script>
